export class MeasurementLineConfig {
}
MeasurementLineConfig.A_color = 0xFF4DDD;
MeasurementLineConfig.B_color = 0xFF4DDD;
MeasurementLineConfig.C_color = 0xFF4DDD;
MeasurementLineConfig.ABLine_color = 0xFF4DDD;
MeasurementLineConfig.lengthLabel_backgroundColor = "rgba(236, 68, 204, 0.6)";
MeasurementLineConfig.lengthLabel_fontColor = "#ffffff";
//# sourceMappingURL=MeasurementLineConfig.js.map